import { useEffect } from 'react'
import nProgress from 'nprogress'

import { Events } from 'constants/events'

const useProgressBar = () => {
  nProgress.configure({ minimum: 0 })

  useEffect(() => {
    const scrollProgress = () => {
      const winHeightPx =
        document.documentElement.scrollHeight - document.documentElement.clientHeight
      const scrollPx = document.documentElement.scrollTop
      const scroll = scrollPx / winHeightPx
      const scrollWithFullState = scroll === 1 ? 0.999 : scroll
      nProgress.set(scrollWithFullState)
    }

    window.addEventListener(Events.SCROLL, scrollProgress)
    return window.addEventListener(Events.SCROLL, scrollProgress)
  }, [])
}

export default useProgressBar
